import { FieldError, FieldErrorsImpl, Merge, UseFormRegister } from 'react-hook-form';

import { FormControl, FormErrorMessage, FormLabel, Radio, RadioGroup, Stack } from '@chakra-ui/react';
import { WarningIcon } from '@udacity/chakra-uds-icons';

import { SelectOption } from '~/types/select-option';

type Props = {
  label: string;
  name: string;
  options: SelectOption[];
  register: UseFormRegister<any>;
  errorMessage?: string | FieldError | Merge<FieldError, FieldErrorsImpl<object>> | undefined;
  isDisabled?: boolean;
  value?: string;
};

export function FormRadioInput({ label, name, options, register, errorMessage, isDisabled, value }: Props) {
  return (
    <FormControl isDisabled={isDisabled} isInvalid={Boolean(errorMessage)}>
      <FormLabel mb={'12px'} data-peer>
        {label}
      </FormLabel>
      <RadioGroup value={value}>
        <Stack gap='12px'>
          {options.map((option) => (
            <Radio key={option.label} {...register(name)} value={option.value}>
              {option.label}
            </Radio>
          ))}
        </Stack>
      </RadioGroup>
      {errorMessage && (
        <FormErrorMessage mt='8px'>
          <>
            <WarningIcon h='26px' w='26px' />
            {errorMessage}
          </>
        </FormErrorMessage>
      )}
    </FormControl>
  );
}
